import React, { Component } from 'react';
import './App.css';
import Timewheel from './components/Timewheel';
import TimewheelThumb from './components/TimewheelThumb';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: false,
      start: -10000,
      end:-5030,
      lang: new URLSearchParams(window.location.search).get("lang") || "en"
    };

    this.handleChange = this.handleChange.bind(this);
  }
  showFull = false;

  handleClick() {
    this.setState({
      isToggleOn: !this.state.isToggleOn
    });
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render() {
    var part = "";

    if (this.state.isToggleOn) {
        part =  <Timewheel lang={this.state.lang} start={this.state.start} end={this.state.end} />
    } else  {
        part = (
          <div>
          <br />
          {
            //START: <input type="number" id="start" name="start" value={this.state.start} onChange={this.handleChange} /> &nbsp; &lt;=&gt;  &nbsp;
          //END: <input type="number" id="end" name="end" value={this.state.end} onChange={this.handleChange} />
          }
          <div onClick={this.handleClick.bind(this)} >
            <TimewheelThumb width="400" height="400"  start={this.state.start} end={this.state.end} />
        </div>
      </div>
    )
    }
    return (
      <div className="App">
        <div className="info">
          <h1>Wheel of Time</h1>
          <div style={{fontSize: 0.7 + 'em'}}>Prototype for a visualization component  <br/>
          developed by <a href="http://www.fooviz.xyz/">Michael Aschauer</a>&nbsp; <br/>
          for <a href="http://www.pancom.at/">Pan Verlag</a> and <a href="http://www.mamuz.at">MAMUZ</a>, &copy; 2019 
          </div>
        </div>
        
        { part  }

      </div>
    );
  }
}

export default App;
